import { Fade } from "@mui/material"

import info from "../../data/info"
import timeout from "../../data/timeout"

const MainTopSection = () => {
  return (
    <div className="px-6 tn:px-8 xs:px-10 sm:px-20 h-screen bg-no-repeat bg-mother-board bg-cover bg-center text-[#E5E5E5] flex items-center justify-center">
      <Fade timeout={timeout + 800} in>
        <div className=" bg-[#002898] font-semibold leading-[2.7rem] tn:leading-[3.5rem] xs:leading-[3.7rem] sm:leading-[4.5rem] text-3xl tn:text-4xl xs:text-5xl sm:text-6xl shadow-[0px_0px_25px_22px] tn:shadow-[0px_0px_25px_22px] xs:shadow-[0px_0px_30px_30px] sm:shadow-[0px_0px_60px_70px] md:shadow-[0px_0px_60px_70px] shadow-[#002898] tn:shadow-[#002898] xs:shadow-[#002898] sm:shadow-[#002898] md:shadow-[#002898] rounded-xl">
          <h1>
            Ремонт
            <br />
            комп'ютерів та ноутбуків
            <br />
            {info.onLocation.ua}
          </h1>
        </div>
      </Fade>
    </div>

    // <div className="relative w-full h-screen overflow-hidden ">
    //   <video
    //     autoPlay
    //     muted
    //     loop
    //     playsInline
    //     className="absolute top-0 left-0 w-full h-full object-cover z-[-1] brightness-75 saturate-150 contrast-125"
    //   >
    //     <source src="/background.mp4" type="video/mp4" />
    //     Ваш браузер не поддерживает видео.
    //   </video>

    //   <div className="relative flex items-center justify-center h-full text-white text-center px-4">
    //     <Fade timeout={timeout + 800} in>
    //       <div className=" bg-[#002898] font-semibold leading-[2.7rem] tn:leading-[3.5rem] xs:leading-[3.7rem] sm:leading-[4.5rem] text-3xl tn:text-4xl xs:text-5xl sm:text-6xl shadow-[0px_0px_25px_22px] tn:shadow-[0px_0px_25px_22px] xs:shadow-[0px_0px_30px_30px] sm:shadow-[0px_0px_60px_70px] md:shadow-[0px_0px_60px_70px] shadow-[#002898] tn:shadow-[#002898] xs:shadow-[#002898] sm:shadow-[#002898] md:shadow-[#002898] rounded-xl">
    //         <h1>
    //           Ремонт
    //           <br />
    //           комп'ютерів та ноутбуків
    //           <br />
    //           {info.onLocation.ua}
    //         </h1>
    //       </div>
    //     </Fade>
    //   </div>
    // </div>
  )
}

export default MainTopSection
